import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Users/";

export function UserVerify(userData) {
  return apiUtils
    .post(`${baseUrl}UserVerify`, userData)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function UserRegister(userData) {
  return apiUtils
    .post(`${baseUrl}UserRegister`, userData)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
